import React, {useMemo} from 'react';
import {ContentItems} from './view';
import {ServicesItem} from './interface';
import {useSelector} from 'react-redux';
import {servicesSelector} from '../../../redux/selectors/resources';
import {Screens} from '../../routing';
import {useNavigation} from '@react-navigation/native';
import {images} from '../../../assets/icons';
import {holderProfileSelector} from '../../../redux/selectors/profile';
import {Content} from '../../models/content';
import {UscType} from '../../models/profile/uscType';
import {useIsDesktop} from '../../hooks/useIsDesktop';

const items: Omit<ServicesItem, 'body' | 'title'>[] = [
  {
    key: Screens.TransportService,
    // title: 'Транспортное приложение',
    icon: ({theme, ...props}) => (
      <images.Transport {...props} color={theme.supportService.iconsColor.transport} hideForVisuallyImpaired />
    ),
  },
  {
    key: Screens.BankingService,
    // title: 'Банковские сервисы',
    icon: ({theme, ...props}) => (
      <images.Banking {...props} color={theme.supportService.iconsColor.banking} hideForVisuallyImpaired />
    ),
  },
  // {
  //   key: Screens.PrivilegesService,
  //   // title: 'Мои льготы',
  //   icon: ({theme, ...props}) => (
  //     <images.Privileges {...props} color={theme.supportService.iconsColor.priveleges} hideForVisuallyImpaired />
  //   ),
  // },
  {
    key: Screens.LoyaltyProgram,
    // title: 'Программа лояльности',
    icon: ({theme, ...props}) => (
      <images.Loyalty {...props} color={theme.supportService.iconsColor.loyalty} hideForVisuallyImpaired />
    ),
  },
  {
    key: Screens.VolunteersService,
    // title: 'Волонтерство',
    icon: ({theme, ...props}) => (
      <images.Volunteering {...props} color={theme.supportService.iconsColor.loyalty} hideForVisuallyImpaired />
    ),
  },
];

interface Props {
  useBackgroundPattern?: boolean;
}

export const ServicesContent: React.FC<Props> = ({useBackgroundPattern}) => {
  const isDesktop = useIsDesktop();
  const nav = useNavigation();

  const services = useSelector(servicesSelector);
  const holderProfile = useSelector(holderProfileSelector());

  const itemsForRender = useMemo(() => {
    if (!holderProfile) return [];

    const disabledItems: {[key in keyof Content['services']]?: boolean} = {};
    if (holderProfile.uscType !== UscType.Financial) {
      disabledItems[Screens.BankingService] = true;
    }
    if (holderProfile?.uscIsBlocked) {
      disabledItems[Screens.BankingService] = true;
      disabledItems[Screens.TransportService] = true;
    }

    return items
      .filter((i) => !disabledItems[i.key])
      .map((i) => ({
        ...i,
        body: services[i.key].cardBody,
        title: services[i.key].cardTitle,
      }));
  }, [items, holderProfile, services]);

  return React.createElement(ContentItems, {
    useBackgroundPattern,
    items: itemsForRender,
    onPress(item: ServicesItem) {
      isDesktop ? nav.navigate(item.key) : nav.navigate(Screens.CardServicesMenu, {screen: item.key, initial: false});
    },
  });
};
